import { date2ViewDate } from '../util/TimeTableUtil';

const DatePickerBox = ({ title, value, size, onChange, disabled = false }) => {
    return (
        <div
            className={
                // size == 'combine'
                //     ? ''
                //     : 'form-box' + (size != undefined ? (size == 'small' ? ' w-sm' : size == 'medium' ? ' w-md' : ' w-lg') : '')
                'form-box' +
                (size != undefined ? (size == 'small' ? ' w-sm' : size == 'medium' ? ' w-md' : ' w-lg') : '')
            }
        >
            <div className='input-box'>
                <label htmlFor={title}>{title}</label>
                <div className='input-group'>
                    <input
                        id={title}
                        type='date'
                        className='form-control ipt-cal'
                        disabled={disabled}
                        value={value}
                        onChange={(e) => onChange(e)}
                    />
                </div>
            </div>
        </div>
    );
};

// const DatePickerBox = ({ title, value, size, onChange, disabled = false }) => {
//     return (
//         <div
//             className={
//                 // size == 'combine'
//                 //     ? ''
//                 //     : 'form-box' + (size != undefined ? (size == 'small' ? ' w-sm' : size == 'medium' ? ' w-md' : ' w-lg') : '')
//                 'form-box' +
//                 (size != undefined ? (size == 'small' ? ' w-sm' : size == 'medium' ? ' w-md' : ' w-lg') : '')
//             }
//         >
//             <div className='input-box'>
//                 <label htmlFor={title}>{title}</label>
//                 <div className='input-group'>
//                     <input
//                         id={title}
//                         type='date'
//                         className='form-control ipt-cal'
//                         disabled={disabled}
//                         value={value}
//                         onChange={(e) => onChange(e)}
//                     />
//                 </div>
//             </div>
//         </div>
//     );
// };

export default DatePickerBox;
